import React from 'react'
import * as Material from '@mui/material'

export const Action = () => <Material.Box pt={6}>
  <Material.Link>
    Aici vine categoria lectiei
  </Material.Link>
</Material.Box>
